import { createSlice } from '@reduxjs/toolkit';
import expenseApi from 'src/api/expense';
import incomeApi from 'src/api/income';


const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  reload: false,
  detail: null
}

const slice = createSlice({
  name: 'expense_detail',
  initialState,
  reducers: {
    setExpenseDetail(oldState, action) {
      oldState.detail = action.payload;
    },

    openModal(oldState) {
      oldState.isModalOpen = true;
    },

    closeModal(oldState) {
      oldState.isModalOpen = false;
      oldState.modalViewName = null;
      oldState.modalViewParams = null;
    },

    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload;
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload;
    },

    setReload(oldState, action) {
      oldState.reload = action.payload;
    },

    setExpenseSearchDate(oldState, action) {
      oldState.startDate = action.payload.startDate
      oldState.endDate = action.payload.endDate
    },

  }
});

export const reducer = slice.reducer;

export const setExpenseDetail = (detail) => (dispatch) => {
  
  dispatch(slice.actions.setExpenseDetail(detail));
};

export const getExpenseDetailById =  (expenseId) => async (dispatch) => {

  const detail = await expenseApi.findExpenseById(expenseId)
  dispatch(slice.actions.setExpenseDetail(detail));
}

// Edit Expense
// {
//   "amount": 0,
//   "comment": "string",
//   "paymentMethodId": 0,
//   "reasonId": 0,
//   "recordDateTime": "2020-12-27T03:52:02.522Z"
// }
export const editExpense =  (expenseId, expenseDto) => async (dispatch) => {

  const detail = await expenseApi.editExpense(expenseId, expenseDto)
  dispatch(slice.actions.setExpenseDetail(detail));
}

//number id
//number courseProductId
export const deleteExpense =  (expenseId) => async (dispatch) => {

  const detail = await expenseApi.deleteExpense(expenseId);
}

export const deleteCashSplitRecord = (cashId) =>async (dispatch) => {

  const detail = await incomeApi.deleteCashSplitRecord(cashId);
}


// Modal
export const setModalViewName = (viewName) => (dispatch) => {

  dispatch(slice.actions.setModalViewName(viewName));
};

export const setModalViewParams = (params) => (dispatch) => {

  dispatch(slice.actions.setModalViewParams(params));
}

export const openModal = () => (dispatch) => {

  dispatch(slice.actions.openModal());
};

export const closeModal = () => (dispatch) => {

  dispatch(slice.actions.closeModal());
};

export const setExpenseSearchDate = (date) => async (dispatch) => {
  dispatch(slice.actions.setExpenseSearchDate(date))
}


// Reload
export const setReload = (reload) => (dispatch) => {
  dispatch(slice.actions.setReload(reload))
}

export default slice;
